import React from 'react';
import { createPortal } from 'react-dom';
import { Wrapper, Header, SubHeader, StyledModal, HeaderText, SubHeaderText, Content, Backdrop, Footer, } from './Modal.styled';
import { ExIcon } from '../assets/icons/ExIcon';
function Modal(_a) {
    var isOpen = _a.isOpen, close = _a.close, headerText = _a.headerText, subHeaderText = _a.subHeaderText, modalContent = _a.modalContent, footerContent = _a.footerContent, _b = _a.width, width = _b === void 0 ? '50%' : _b, _c = _a.height, height = _c === void 0 ? 'fit-content' : _c;
    var modal = (React.createElement(React.Fragment, null,
        React.createElement(Backdrop, null),
        React.createElement(Wrapper, null,
            React.createElement(StyledModal, { width: width, height: height },
                React.createElement(Header, null,
                    React.createElement(HeaderText, null, headerText),
                    React.createElement(ExIcon, { onClick: close })),
                React.createElement(SubHeader, null,
                    React.createElement(SubHeaderText, null, subHeaderText)),
                React.createElement(Content, null, modalContent),
                React.createElement(Footer, null, footerContent)))));
    return isOpen ? createPortal(modal, document.body) : null;
}
export default Modal;
